import * as React from 'react';
import { styles } from './styles';
import { Columns } from '@joykit';
import { JoyLogo } from '../../../../DesignDemo/components/JoyLogo';
import InlineSVG from 'svg-inline-react';
import { cx } from 'emotion';
import MediaQuery from 'react-responsive';
import { ChevronDown } from '@routes/event/create/components/ChevronDown';
import { MarketingNavItem, FeatureNavItem, MarketingNavKey } from '../../index';
import { Analytics } from '@withjoy/web-core';
const searchSvg = require('@assets/icons/icon-search.svg');

interface NavProps {
  featureNavItems: FeatureNavItem[];
  marketingNavItems: MarketingNavItem[];
  analytics: Analytics;
  mobileNavOpen: boolean;
  handleMobileNavClose: (event: React.MouseEvent<HTMLMainElement, MouseEvent>) => void;
  handleMobileNavOpen: (event: React.MouseEvent<HTMLMainElement, MouseEvent>) => void;
}

interface NavState {
  featuresIsOpen: boolean;
}

export class MarketingSiteNav extends React.PureComponent<NavProps, NavState> {
  state: NavState = {
    featuresIsOpen: false
  };

  handleToggleFeatures = () => {
    this.props.analytics.track({
      action: 'FeaturesToggle',
      label: 'features'
    });

    this.setState((state: NavState) => {
      return {
        featuresIsOpen: !state.featuresIsOpen
      };
    });
  };

  renderFeatureBar = () => {
    const { featureNavItems, analytics } = this.props;
    return (
      <div className={styles.featureListContainer(this.state.featuresIsOpen)}>
        <div className={styles.featureContainer}>
          <ul className={styles.featureList}>
            {featureNavItems.map(feature => (
              <li key={feature.key}>
                <a className={styles.featureLink} href={feature.url} onClick={() => analytics.track(feature.track)}>
                  <div className={styles.featureIcon(feature.icon)} />
                  {feature.text}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  };

  render(): React.ReactNode {
    const { marketingNavItems, analytics } = this.props;
    return (
      <>
        <nav className={styles.container}>
          <MediaQuery minWidth={1200}>
            {match => (
              <Columns>
                <Columns.Column tablet={2} desktop={match ? 3 : 2}>
                  <a aria-label="Go to withjoy.com" href="https://withjoy.com/">
                    <JoyLogo />
                  </a>
                </Columns.Column>
                <Columns.Column>
                  <ul className={styles.listContainer}>
                    {marketingNavItems.map(({ text, url, key, track }) => {
                      const isDesign = key === MarketingNavKey.designs;
                      const isFeatures = key === MarketingNavKey.features;
                      return (
                        <li key={text} className={styles.listItem}>
                          {isFeatures ? (
                            <a
                              className={cx(styles.navLink, isFeatures && 'active')}
                              onClick={this.handleToggleFeatures}
                            >
                              <span className={styles.carrotContainer}>
                                {text}
                                <ChevronDown className={styles.chevron(this.state.featuresIsOpen)} />{' '}
                              </span>
                            </a>
                          ) : (
                            <a
                              className={cx(styles.navLink, isDesign && 'active')}
                              href={isDesign ? undefined : url}
                              onClick={() => analytics.track(track)}
                            >
                              {text}
                            </a>
                          )}
                        </li>
                      );
                    })}
                    <li className={styles.listItem}>
                      <a className={styles.navButton} href="https://withjoy.com/find">
                        <InlineSVG src={searchSvg} className={styles.svg} />
                        <span>Find an Event</span>
                      </a>
                    </li>
                    <li className={styles.listItem}>
                      <a className={styles.navButton} href="https://withjoy.com/login">
                        Log in
                      </a>
                    </li>
                  </ul>
                </Columns.Column>
              </Columns>
            )}
          </MediaQuery>
        </nav>
        {this.renderFeatureBar()}
      </>
    );
  }
}
